import 'vue/jsx'

// 引入windi css
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 路由
import { setupRouter } from './router'

// 权限
import { setupPermission } from './directives'

import { createApp } from 'vue'

import { initAppBrand } from '@/utils/initAppBrand'
import { startIdleWatch } from '@/utils/idleTimeout'

import App from './App.vue'

/** 旧版 pinia 动态路由缓存版本号；仅升级时清一次，避免每次刷新都重拉菜单导致长时间 loading/白屏感 */
const PERMISSION_CACHE_VERSION = 'v7-wallet-withdraw-menu'
const clearStalePermissionCache = () => {
  const versionKey = 'app-permission-cache-version'
  if (localStorage.getItem(versionKey) === PERMISSION_CACHE_VERSION) {
    return
  }
  const cacheKeys = [
    'permission',
    'permission-routers',
    'permission-addRouters',
    'permission-menuTabRouters'
  ]
  cacheKeys.forEach((key) => localStorage.removeItem(key))
  localStorage.setItem(versionKey, PERMISSION_CACHE_VERSION)
}

// 创建实例
const setupAll = async () => {
  clearStalePermissionCache()

  const app = createApp(App)

  await setupI18n(app)

  setupStore(app)

  // 品牌资源（系统名称 / favicon）异步加载，不阻塞挂载
  void initAppBrand()

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  setupPermission(app)

  app.mount('#app')

  // 无操作 120 分钟自动退出（登录页 / SSO 回调除外）
  startIdleWatch()
}

import './permission'

setupAll()
